/**
 * Provide basic custom elements for the popup implementation.
 *
 * @module
 */
import { connectedCallback, HTMLElement } from "@acng/frontend-bounty/dom/custom.js";
import { setContainer } from "./controller.js";
import { globalPopupController, providePopupController } from "./context.js";
import { createDropdown } from "./dropdown.js";
export class PopupElement extends HTMLElement {
    constructor() {
        super();
        createDropdown(this);
    }
    [connectedCallback]() {
        providePopupController(this);
    }
}
export class GlobalPopupElement extends HTMLElement {
    [connectedCallback]() {
        setContainer(globalPopupController, this);
    }
}
